import { FieldConfig } from '../../financialEntities';

export const isInvalidForm = (
    form: Record<string, any>,
    fields: FieldConfig[]
) => {
    return fields.some(({ isRequired, isVisible, name }) => {
        // If field is not visible, skip validation
        if (isVisible?.(form) === false) return false;
        // Otherwise, check if field is required and empty
        const value = form[name];
        return (
            isRequired &&
            (value === null || value === undefined || value === '')
        );
    });
};
